import * as React from "react";
import {Fragment} from "react";
import {withRouter} from "react-router-dom";
import QuotationTypeService from "../services/Transaction/QuotationTypeService";
import CountryService from "../services/Transaction/CountryService";
import PayoutMethodService from "../services/Transaction/PayoutMethodService";
import PayoutPartnerService from "../services/Transaction/PayoutPartnerService";
import CurrencyService from "../services/Transaction/CurrencyService";
import QuotationRequest, {getAmountValidation} from "../domain/Transaction/QuotationRequest";
import QuotationService from "../services/Transaction/QuotationService";
import {Card, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import DropdownComponent from "./DropdownComponent";
import SFXButtonComponent from "./SFXButtonComponent";
import SFXLoadingComponent from "./SFXLoadingComponent";

class QuotationComponent extends React.Component {

    constructor(props) {
        super(props);

        if (props.quotationRef) {
            props.quotationRef(this);
        }

        this.state = {
            quotationTypeOptions: null,
            countryOptions: null,
            payoutMethodOptions: null,
            payoutPartnerOptions: null,
            currencyOptions: null,

            country: {"id": 0, "name": ""},
            payoutMethod: {"id": 0, "name": ""},
            payoutPartner: {"id": 0, "name": ""},
            currency: {"id": 0, "name": ""},
            quotationType: {"id": "SENDER_AMOUNT", "name": "Amount (Excluding Fees)"},
            amount: "",

            loading: true,
            showQuotationErrorModal: false,
            quotationErrors: [],

            inValidFields: {},
            validFields: {}
        };

        this.schema = {
            amount: getAmountValidation("Amount", true)
        }

    }

    componentDidMount() {

        if (this.props.setHeader)
            this.props.setHeader();

        let promiseArr = [];

        promiseArr.push(QuotationTypeService.retrieveQuotationTypes());
        promiseArr.push(CountryService.retrieveCountriesForTransaction());

        Promise.all(promiseArr).then(promiseArrResponse => {
            this.setState({
                quotationTypeOptions: promiseArrResponse[0],
                countryOptions: promiseArrResponse[1],
                loading: false
            })
        });

    }

    retrievePayoutMethods() {

        if (this.state.country.id !== 0) {
            PayoutMethodService.retrievePayoutMethodsForCountry(this.state.country.id).then(response => {
                if (response.length === 1) {
                    let event = {
                        "id": response[0].id,
                        "name": response[0].name
                    };
                    this.setState({
                        payoutMethodOptions: response
                    }, () => this.dropdownChange(event, "payoutMethod"))
                } else {
                    this.setState({
                        payoutMethodOptions: response
                    })
                }
            })
        }
    }

    retrievePayoutPartners() {

        if (this.state.payoutMethod.id !== 0) {
            PayoutPartnerService.retrievePayoutPartnerForPayoutMethod(this.state.payoutMethod.id).then(response => {
                if (response.length === 1) {
                    let event = {
                        "id": response[0].id,
                        "name": response[0].name
                    };
                    this.setState({
                        payoutPartnerOptions: response
                    }, () => this.dropdownChange(event, "payoutPartner"))
                } else {
                    this.setState({
                        payoutPartnerOptions: response
                    })
                }
            })
        }
    }

    retrieveCurrencies() {

        if (this.state.payoutPartner.id !== 0) {
            CurrencyService.retrieveCurrenciesForPayoutPartner(this.state.payoutPartner.id).then(response => {
                if (response.length === 1) {
                    let event = {
                        "id": response[0].id,
                        "name": response[0].name
                    };
                    this.setState({
                        currencyOptions: response
                    }, () => this.dropdownChange(event, "currency"))
                } else {
                    this.setState({
                        currencyOptions: response
                    })
                }
            })
        }
    }

    resetAndRetrieveNewOptions(field) {

        let defaultDropdownState = {"id": 0, "name": ""};

        switch (field) {
            case "country":
                this.setState({
                    payoutMethod: defaultDropdownState,
                    payoutMethodOptions: null,
                    payoutPartner: defaultDropdownState,
                    payoutPartnerOptions: null,
                    currency: defaultDropdownState,
                    currencyOptions: null,
                    quotationType: this.state.quotationType,
                    amount: this.state.amount
                }, this.retrievePayoutMethods);
                break;
            case "payoutMethod":
                this.setState({
                    payoutPartner: defaultDropdownState,
                    payoutPartnerOptions: null,
                    currency: defaultDropdownState,
                    currencyOptions: null,
                    quotationType: this.state.quotationType,
                    amount: this.state.amount
                }, this.retrievePayoutPartners);
                break;
            case "payoutPartner":
                this.setState({
                    currency: defaultDropdownState,
                    currencyOptions: null,
                    quotationType: this.state.quotationType,
                    amount: this.state.amount
                }, this.retrieveCurrencies);
                break;
            case "currency":
                this.setState({
                    quotationType: this.state.quotationType,
                    amount: this.state.amount
                });
                break;
            case "quotationType":
                this.setState({
                    amount: this.state.amount
                });
                break;
            default:
                break;
        }
    }

    validateInputFields(field) {

        let self = this;
        let previousInvalidValidations = {...this.state.inValidFields};
        delete previousInvalidValidations[field];
        let previousValidValidations = {...this.state.validFields};
        previousValidValidations[field] = true;

        this.setState({
            inValidFields: previousInvalidValidations,
            validFields: previousValidValidations
        }, () => {

            let fieldValue = this.state[field];

            if (this.schema[field] !== undefined) {
                this.schema[field].validate({[field]: fieldValue}).catch(function (err) {

                    let previousInvalidValidations = {...self.state.inValidFields};
                    previousInvalidValidations[field] = err.message;
                    let previousValidValidations = {...self.state.validFields};
                    delete previousValidValidations[field];

                    self.setState({
                        inValidFields: previousInvalidValidations,
                        validFields: previousValidValidations
                    });
                })
            }
        })

    }

    handleChange = (event, field) => {
        this.setState({
            [field]: event.target.value
        });

        if (field === "amount") {
            this.validateInputFields(field);
        }
    };

    dropdownChange = (event, field) => {

        let newState;
        if (event !== null) {
            newState = {
                id: event.id,
                name: event.name
            };
        } else {
            if (field === "quotationType") {
                newState = {
                    id: "",
                    name: ""
                }
            } else {
                newState = {
                    id: 0,
                    name: ""
                }
            }
        }

        if (newState.id !== this.state[field].id) {
            this.setState({[field]: newState}, () => this.resetAndRetrieveNewOptions(field));
        }
    };

    isValid() {

        return (
            (this.state.country.id > 0) &&
            (this.state.payoutMethod.id > 0) &&
            (this.state.payoutPartner.id > 0) &&
            (this.state.currency.id > 0) &&
            (this.state.quotationType.id !== "") &&
            (this.state.validFields["amount"])
        )
    }

    getQuotation() {

        let quote = {};

        quote = QuotationRequest.create(
            this.state.country.id,
            this.state.payoutMethod.id,
            this.state.payoutPartner.id,
            this.state.currency.id,
            this.state.quotationType.id,
            this.state.amount,
            this.props.registrationId
        );

        this.setState({
            loading: true,
            quotationRequest: quote
        });

        QuotationService.requestQuotation(quote).then(response => {
            if (response["error-code"]) {
                this.setState({
                    loading: false,
                    showQuotationErrorModal: true,
                    quotationErrors: response["errors"]
                })
            } else {
                this.setState({
                    loading: this.props.continueLoading === undefined ? true : this.props.continueLoading,
                    quotationResponse: response
                }, () => this.props.returnQuotationResponse(quote, response))
            }
        })
    }

    render() {

        if (this.state.loading)
            return <SFXLoadingComponent/>;

        return <Fragment>

            {this.props.className === 'mobile' ? this.renderQuotationRequest('mobile') : this.renderBrowserQuotationRequest('browser')}

        </Fragment>

    }

    renderQuotationRequest(className) {

        return <Fragment>

            {this.renderErrorModal(className)}

            <div className={className + "_main_quotation_screen"}>
                {
                    this.state.countryOptions === null
                        ? this.renderLoadingText(className)
                        : this.state.countryOptions.length === 0
                        ? this.renderNoOptionsText(className, "Countries")
                        : this.renderDropdown(className, this.state.countryOptions, "country", "Select your country")
                }
                {
                    this.state.country.id > 0 &&
                    (
                        this.state.payoutMethodOptions === null
                            ? this.renderLoadingText(className)
                            : this.state.payoutMethodOptions.length === 0
                            ? this.renderNoOptionsText(className, "Payout Methods")
                            : this.renderDropdown(className, this.state.payoutMethodOptions, "payoutMethod", "Select your payout method")
                    )
                }
                {
                    this.state.payoutMethod.id > 0 &&
                    (
                        this.state.payoutPartnerOptions === null
                            ? this.renderLoadingText(className)
                            : this.state.payoutPartnerOptions.length === 0
                            ? this.renderNoOptionsText(className, "Payout Partners")
                            : this.renderDropdown(className, this.state.payoutPartnerOptions, "payoutPartner", "Select your payout partner")
                    )
                }
                {
                    this.state.payoutPartner.id > 0 &&
                    (
                        this.state.currencyOptions === null
                            ? this.renderLoadingText(className)
                            : this.state.currencyOptions.length === 0
                            ? this.renderNoOptionsText(className, "Currencies")
                            : this.renderDropdown(className, this.state.currencyOptions, "currency", "Select your currency")
                    )
                }
                {
                    this.state.currency.id > 0 &&
                    (
                        this.state.quotationTypeOptions === null
                            ? this.renderLoadingText(className)
                            : this.state.quotationTypeOptions.length === 0
                            ? this.renderNoOptionsText(className, "Quotation Types")
                            : this.renderDropdown(className, this.state.quotationTypeOptions, "quotationType", "Select the sender cost")
                    )
                }
                {
                    this.state.currency.id > 0 && this.state.quotationType.id.length > 0 &&
                    this.renderInput(className, "amount", "Select the amount")
                }

                {this.renderGetQuoteButton(className)}
            </div>

        </Fragment>

    }

    renderBrowserQuotationRequest(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderQuotationRequest(className)}
        </Card>
    }

    renderGetQuoteButton(className) {

        return <Fragment>
            {className === "browser" ? <br/> : <Fragment></Fragment>}
            <div className={className + "_register_button_div"}>
                <SFXButtonComponent
                    className={className + "_orange_oval_button"}
                    onClick={() => this.getQuotation()}
                    disabled={!this.isValid()}
                >Get Quote
                </SFXButtonComponent>
            </div>
        </Fragment>
    }

    renderInput(className, field, text) {

        return <Fragment>

            <Row className={className + "_row"}>
                <Col>
                    <Input
                        className={className + "_input"}
                        value={this.state[field]}
                        placeholder={text}
                        onChange={(event) => this.handleChange(event, field)}
                    />
                    {this.state.inValidFields[field] && this.renderErrorMessage(className, field, this.state.inValidFields[field])}
                </Col>
            </Row>

        </Fragment>

    }

    renderDropdown(className, dropdownOptions, field, text) {

        return <Fragment>

            <Row className={className + "_row"}>
                <Col>
                    <DropdownComponent
                        className={className + "_dropdown"}
                        value={this.state[field].id || ""}
                        options={dropdownOptions}
                        placeholder={text}
                        onChange={(selectedOption) => {
                            this.dropdownChange(selectedOption, field)
                        }}
                        clearable={true}
                        disabled={dropdownOptions.length === 1}
                    />
                </Col>
            </Row>

        </Fragment>
    }

    renderErrorMessage(className, field, message) {
        return <h6 className={className + "_error_text"}>
            {message}
        </h6>;
    }

    renderErrorModal(className) {

        return <Modal isOpen={this.state.showQuotationErrorModal}>

            <ModalHeader className={className + "_modal_header"}>Invalid Input</ModalHeader>
            <ModalBody>{this.state.quotationErrors}</ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.setState({showQuotationErrorModal: false})}
                >
                    Close
                </SFXButtonComponent>
            </ModalFooter>

        </Modal>

    }

    renderLoadingText(className) {

        return <Row className={className + "_row"}>
            <Col>
                Loading...
            </Col>
        </Row>

    }

    renderNoOptionsText(className, field) {

        return <Row className={className + "_row"}>
            <Col>
                No {field} available
            </Col>
        </Row>

    }

}

export default withRouter(QuotationComponent);